<template>
  <div class="days-free">
    <div class="form-group">
      <label for>Dias Grátis</label>
      <input type="number" class="form-control" v-model="data.value" />
    </div>
  </div>
</template>

<script>
export default {
  name: "days-free",
  props: {
    data: Object
  }
};
</script>

<style>
</style>